import request from '../../request';

const moment = window.moment;

export default {
  namespaced: true,
  state: {
    loadingTimes: false, // Loading timeslots?
    updateCalendar: false,
    calendar: [],
    selectedDay: undefined,
    times: [],
    selectedTimeIndex: undefined,
  },
  mutations: {
    setAvailableDays(state, payload) {
      Object.assign(state, { calendar: [] });
      const newCalendar = [];
      payload.forEach((availableDay) => {
        const newDay = {
          id: availableDay.id,
          allDay: true,
          start: availableDay.date,
        };
        if (window.moment(availableDay.date).isBefore()) {
          newDay.className = 'oldOccurrence';
        }
        newCalendar.push(newDay);
      });
      Object.assign(state, { calendar: newCalendar });
      Object.assign(state, { updateCalendar: true });
    },
    setUpdateCalendar(state, payload) {
      Object.assign(state, { updateCalendar: payload });
    },
    setLoadingTimes(state, payload) {
      Object.assign(state, { loadingTimes: payload });
    },
    setAvailableTimes(state, payload) {
      Object.assign(state, { times: payload });
    },
    resetTimes(state) {
      Object.assign(state, { times: [] });
    },
    setSelectedDay(state, payload) {
      Object.assign(state, { selectedDay: payload });
    },
    setSelectedTimeIndex(state, payload) {
      Object.assign(state, { selectedTimeIndex: payload });
    },
    resetSelectedTimeIndex(state) {
      Object.assign(state, { selectedTimeIndex: undefined });
    },
  },
  actions: {
    getAvailableTimes(context, payload) {
      context.commit('resetTimes');
      context.commit('setLoadingTimes', true);
      context.commit('resetSelectedTimeIndex');
      context.dispatch('bookingPublic/resetPersons', undefined, { root: true });
      const data = {
        date: payload,
        activity: context.rootState.activityPublic.activity.id,
      };
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}activity_calendar`,
        data,
      }, (err, res) => {
        context.commit('setLoadingTimes', false);
        context.commit('setSelectedDay', payload);
        if (res.status === 200) {
          context.commit('setAvailableTimes', res.body.data);
          if (res.body.data.length === 1) {
            context.commit('setSelectedTimeIndex', 0);
          }
        }
      });
    },
    getCalendarForActivity(context, payload) {
      context.commit('resetTimes');
      context.commit('resetSelectedTimeIndex');
      context.dispatch('bookingPublic/resetPersons', undefined, { root: true });
      let startDate = moment()
      .date(1)
      .subtract(1, 'month')
      .format('YYYY-MM-DD');
      let endDate = moment()
      .date(31)
      .add(1, 'month')
      .format('YYYY-MM-DD');
      if (typeof payload.startDate !== 'undefined') {
        startDate = payload.startDate;
      }
      if (typeof payload.endDate !== 'undefined') {
        endDate = payload.endDate;
      }
      const data = {
        activity: payload.activityId,
        start_date: startDate,
        end_date: endDate,
      };

      request.make({
        type: 'GET',
        url: `${process.env.API_URL}activity_calendar`,
        data,
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('setAvailableDays', res.body.data);
        }
      });
    },
    setSelectedTimeIndex(context, payload) {
      context.commit('setSelectedTimeIndex', payload);
      context.dispatch('bookingPublic/resetPersons', undefined, { root: true });
    },
    setUpdatePublicCalendar(context, payload) {
      context.commit('setUpdateCalendar', payload);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/public/calendar.js